module.exports = __webpack_public_path__ + "static/media/img_40-49.3d5a6d4e.png";